<template>
    <div class="pupil-dashboard">
        <!--   pupil  -->
        <div class="p-grid p-jc-center  ">
            <div class="p-pt-5 p-ai-center p-grid p-jc-center">
                <div
                        v-if="user.role === 'ADMIN'"
                        class=" p-col  "
                >


                    <div class="p-inputgroup">
                        <Button
                                v-tooltip.top="'הכיתה הקודמת'"
                                @click="navigateGrades(false)"
                                icon="pi  pi-angle-up"
                                class="
                    button-grade-back
                    p-inputgroup-addon
                    plus
                    p-button-secondary p-inputgroup-addon
                  "
                        ></Button>

                        <Dropdown
                                style="text-align: center"
                                filterPlaceholder=" חפש לפי כיתה"
                                emptyFilterMessage=" לא נמצא שם כיתה תואם"
                                :filter="true"
                                class=""
                                optionLabel="hebrewName"
                                v-model="selectedGrade"
                                :options="gradeOptions"
                                placeholder="בחר כיתה"
                                data-key="id"
                                @input=" (update = 0)"
                        >
                            <template #value="slotProps">
                                <div v-if="slotProps.value">
                                    <span>{{ slotProps.value.hebrewName }}</span>
                                </div>
                                <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                            </template>
                            <template #option="slotProps">
                                <span>{{ slotProps.option.hebrewName }}</span>
                            </template>
                        </Dropdown>

                        <Button
                                v-tooltip.top="'הכיתה הבאה'"
                                @click="navigateGrades(true)"
                                icon="pi  pi-angle-down"
                                class="plus p-button-secondary p-inputgroup-addon"
                        ></Button>
                    </div>
                </div>
                <div class="p-col ">
                    <div class="p-inputgroup">
                        <Button
                                v-tooltip.top="'התלמיד הקודם'"
                                @click="navigatePupil(false)"
                                icon="pi  pi-angle-up"
                                class="
                    button-grade-back
                    p-inputgroup-addon
                    plus
                    p-button-secondary p-inputgroup-addon
                  "
                        ></Button>

                        <Dropdown
                                style="text-align: center"
                                filterPlaceholder=" חפש לפי שם משפחה"
                                emptyFilterMessage=" לא נמצא שם משפחה תואם"
                                class=""
                                :filter="true"
                                optionLabel="lastname"
                                v-model="pupil"
                                :options="userPupils"
                                placeholder="בחר תלמיד"
                                dataKey="id"
                        >
                            <template #value="slotProps">
                                <div v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ slotProps.placeholder }}
                                </div>
                                <span v-else>
              {{ slotProps.value.firstname }} {{ slotProps.value.lastname }}
            </span>
                            </template>
                            <template #option="slotProps">
            <span>{{ slotProps.option.grade.hebrewName }}:
              {{ slotProps.option.firstname }}
              {{ slotProps.option.lastname }}</span>
                            </template>
                        </Dropdown>

                        <Button
                                v-tooltip.top="'התלמיד הבא'"
                                @click="navigatePupil(true)"
                                icon="pi  pi-angle-down"
                                class="plus p-button-secondary p-inputgroup-addon"
                        ></Button>
                    </div>
                </div>

                <Calendar
                        style="text-align: center !important"
                        class="calendar-hebrew calendar-picker-presence p-m-3"
                        :manualInput="false"
                        :disabledDays="[6]"
                        v-model="startDate"
                        :showButtonBar="true"
                        :dateFormat="dateformat(startDate)"
                />
                <Calendar
                        style="text-align: center !important"
                        class="calendar-hebrew calendar-picker-presence p-m-3"
                        :manualInput="false"
                        :disabledDays="[6]"
                        v-model="endDate"
                        :showButtonBar="true"
                        :dateFormat="dateformat(endDate)"
                />
            </div>
        </div>
        <div style="" class="p-grid p-p-2">

            <TotalPresenceCard
                    class="p-col-12 p-sm-12 p-md-6 p-lg-4"
                    :pupil="pupil"
                    :startDate="startDate.getTime()"
                    :endDate="endDate.getTime()"
            />
            <LessonTimeLine
                    class="p-col-12 p-sm-12  p-md-6 p-lg-4"
                    :pupil="pupil"
                    :startDate="startDate.getTime()"
                    :endDate="endDate.getTime()"
            />
            <TotalTracingCard
                    class="p-col-12 p-sm-12  p-md-6 p-lg-4"
                    :pupil="pupil"
                    :startDate="startDate.getTime()"
                    :endDate="endDate.getTime()"
            />
            <TotalTestCard
                    class="p-col-12 p-sm-12  p-md-6 p-lg-4"
                    :pupil="pupil"
                    :startDate="startDate.getTime()"
                    :endDate="endDate.getTime()"
            />

        </div>


    </div>
</template>

<script>
import {mapState} from "vuex";
import TotalPresenceCard from "./totalPresence/TotalPresenceCard";
import TotalTracingCard from "./totalTracking/TotalTracingCard";
import TotalTestCard from "./totalTest/TotalTestCard";
import LessonTimeLine from "../pupilDashboard/lessonTmeLine/LessonTimeLine.vue";
import {dateToFullHebrew} from "@/utils/hebrewDateFormat";

const LOCAL_STORAGE = 'pupil-dashboard'
const startDateInit = new Date();
startDateInit.setDate(startDateInit.getDate() - 7);

export default {
    name: "pupilDashboard",
    components: {TotalPresenceCard, TotalTracingCard, TotalTestCard, LessonTimeLine},
    data() {
        return {
            pupil: null,
            startDate: startDateInit,
            endDate: new Date(),
            selectedGrade: null
        };
    },
    mounted() {
        if (this.user.role !== 'ADMIN') {
            this.selectedGrade = this.user.grade.id
        }
    },
    created() {
        if (!this.getLocalstorage()) {
            if (this.user.grade === null) {
                this.pupil = this.pupils?.[0];
            } else {
                this.pupil = this.userPupils?.[0];
            }
        }
    },
    methods: {
        navigateGrades(isAdd) {
            const index = this.gradeOptions.findIndex(
                (grade) => grade.id === this.selectedGrade.id
            );
            this.selectedGrade =
                this.gradeOptions[
                ((isAdd ? index + 1 : index - 1) + this.gradeOptions.length) %
                this.gradeOptions.length
                    ];

        },
        navigatePupil(isAdd) {
            const index = this.userPupils.findIndex(
                (pupil) => pupil.id === this.pupil.id
            );
            this.pupil =
                this.userPupils[
                ((isAdd ? index + 1 : index - 1) + this.userPupils.length) %
                this.userPupils.length
                    ];

            // this.showAllPresence = false;
            // setTimeout(() => (this.showAllPresence = true), 25);
        },
        dateformat(date) {
            return dateToFullHebrew(date);
        },
        getLocalstorage() {
            const obj = JSON.parse(localStorage.getItem(LOCAL_STORAGE))
            if (obj) {
                this.selectedGrade = obj.selectedGrade
                this.pupil = obj.pupil
                this.startDate = new Date(obj.startDate)
                this.endDate = new Date(obj.endDate)
                return true
            }
        },
        updateLocalstorage() {
            localStorage.setItem(LOCAL_STORAGE, JSON.stringify(({
                selectedGrade: this.selectedGrade,
                pupil: this.pupil,
                startDate: this.startDate,
                endDate: this.endDate
            })))
        }
    },
    computed: {
        ...mapState(["intro", "pupils", "user", "gradeOptions"]),
        userPupils() {
            if (this.user?.role !== "ADMIN") {
                return this.pupils?.filter((p) => p.grade?.id === this.user.grade);
            } else {
                return this.pupils?.filter((p) => p.grade?.id ===
                    this?.selectedGrade?.id);
            }
        }
    },
    watch: {
        pupil(newValue, oldValue) {
            this.updateLocalstorage()
        },
        selectedGrade(newValue, oldValue) {
            this.updateLocalstorage()
        },
        startDate(newValue, oldValue) {
            this.updateLocalstorage()
        },
        endDate(newValue, oldValue) {
            this.updateLocalstorage()
        }
    }
};
</script>

<style>
@media screen and (max-width: 1200px) {
    .presence-show {
        width: 70rem !important;
    }
}

@media screen and (max-width: 992px) {
    .presence-show {
        width: 95vw !important;
    }
}

@media screen and (max-width: 768px) {
    .presence-show {
        width: 97vw !important;
    }
}

@media screen and (max-width: 576px) {
    .presence-show {
        width: 100vw !important;
    }
}
</style>
